/**
 * HOMEPAGE ARCHIVE: Original Version
 * Last active: Pre-December 2024
 * 
 * This was the first iteration of the VGP homepage.
 * Focused on SMB clients with general lead generation messaging.
 * Archived for LinkedIn case study on website evolution.
 */

import Hero from "@/components/Hero";
import ChallengeOpportunity from "@/components/ChallengeOpportunity";
import WebsiteAudit from "@/components/WebsiteAudit";
import HowWeHelp from "@/components/HowWeHelp";
import WebsiteCTA from "@/components/WebsiteCTA";
import Testimonials from "@/components/Testimonials";
import EnhancedSEO from "@/components/SEO/EnhancedSEO";

const HomeOriginal = () => {
  return (
    <>
      <EnhancedSEO 
        type="homepage"
        title="VGP | Premium Expert Marketing - Scale Your Business With Proven SEO & Lead Generation"
        description="We help premium businesses attract high-value clients through targeted marketing strategies. Transform your client base with our proven SEO and lead generation systems that deliver 150% average revenue increases."
        keywords="premium marketing, SEO services, lead generation, digital growth, business scaling, high-ticket clients, revenue growth, digital marketing agency UK"
        url="/archive/home-original"
      />
      <div className="min-h-screen bg-background">
        {/* Archive Notice Banner */}
        <div className="bg-amber-500/90 text-amber-950 py-3 px-4 text-center font-medium">
          <span className="text-sm">📦 Archive: Original Homepage (Pre-December 2024) — </span>
          <a href="/" className="underline hover:no-underline">View Current Site →</a>
        </div>
        <Hero />
        <ChallengeOpportunity />
        <WebsiteAudit />
        <HowWeHelp />
        <WebsiteCTA />
        <Testimonials />
      </div>
    </>
  );
};

export default HomeOriginal;
